import { mapActions, mapGetters } from 'vuex';
import { FuzzySearch } from '@garmin/support-fuzzy-search';
import ScAutocomplete from '@garmin/support-components/src/components/ScAutocomplete/index.vue';
import TransitionViewBeforeEnterGuard from '../../router/guards/beforeEnter/transitionView';
import subViewsComponentList from './sub-views';
import '@garmin/regalia/icons/arrow-right/icon';

/**
 * Mixins
 */
import TranslationsMixin from '../../mixins/translations';

export default {
  title() {
    return `${this.systemConfig.mode} Support`;
  },
  name: 'TransitionView',
  mixins: [TranslationsMixin],
  components: {
    ScAutocomplete,
  },
  beforeRouteUpdate(to, from, next) {
    TransitionViewBeforeEnterGuard(to, from, next);
  },
  data() {
    return {
      subViews: subViewsComponentList,
      autocompleteFilterFunc: FuzzySearch.isFuzzyMatch,
      internalProductSearch: '',
      internalSelectedProduct: '',
    };
  },
  mounted() {
    this.fetchProductsByLocale();
  },
  computed: {
    ...mapGetters('SSM/', [
      'systemConfig',
      'locale',
      'isLoading',
    ]),
    ...mapGetters('SSM/product', [
      'productList',
      'productDetails',
      'hasErrorFetchingProduct',
      'getProductSelectedIdentifier',
      'findSelectedProductInListByIdentifier',
    ]),
    getSubView() {
      const subViewKey = this.$route.params.transitionName;
      const subView = this.subViews?.find((e) => e[subViewKey]);
      return (
        (subView && subView[subViewKey])
        || null
      );
    },
  },
  methods: {
    ...mapActions('SSM/product', [
      'resetProductDetails',
      'fetchProductDetailsByIdentifier',
      'fetchProductsByLocale',
      'toggleProductSearchError',
    ]),
    async onProductSearchSelected(termOrItem) {
      const identifier = this.getProductSelectedIdentifier(termOrItem);

      if (identifier) {
        this.internalSelectedProduct = termOrItem;
        await this.fetchProductDetailsByIdentifier({ identifier });

        if (!this.hasErrorFetchingProduct) {
          this.$router.push({
            name: 'tabsView',
            params: {
              tabId: this.$route.params.transitionName,
              showTopics: false,
              fromTransition: true,
            },
            query: {
              ...this.$route.query,
              identifier,
            },
          });
        }
      }
    },
    onProductSearchInput(e) {
      this.toggleProductSearchError(false);
      this.internalProductSearch = e.search;
    },
    removeProductSelection() {
      this.internalSelectedProduct = '';
      this.internalProductSearch = '';
      this.resetProductDetails();
    },
  },
};
